import { NgModule } from '@angular/core';
import { ioteqTailwindService } from '@tools/services/tailwind/tailwind.service';

@NgModule({
    providers: [
        ioteqTailwindService
    ]
})
export class ioteqTailwindConfigModule
{
    /**
     * Constructor
     */
    constructor(private _ioteqTailwindConfigService: ioteqTailwindService)
    {
    }
}
